import React from "react";

const timelineEvents = [
  {
    year: "1996",
    title: "1st Store",
    description: "Opening of the first store in Gajuwaka."
  },
  {
    year: "2004",
    title: "2nd Store",
    description: "Expansion with a new branch in Vizag."
  },
  {
    year: "2012",
    title: "3rd Store",
    description: "Launch of our premium showroom in MVP Colony."
  },
  {
    year: "2018",
    title: "Online Store",
    description: "Bringing our authentic jewelry to the digital sphere."
  },
  {
    year: "2021",
    title: "Global Reach",
    description: "Shipping internationally to over 50 countries."
  }
];

const JourneyTimeline = () => {
  return (
    <div className="w-full bg-[#fdfaf5] py-16 md:py-24 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-serif text-[#D4AF37] mb-3">
          Our Journey
        </h2>
        <p className="text-gray-500 text-sm uppercase tracking-widest mb-16">
          A glorious path of trust and purity since 1996
        </p>

        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-[2px] bg-[#D4AF37]"></div>

          <div className="flex flex-col gap-12">
            {timelineEvents.map((event, index) => {
              const isEven = index % 2 === 0;

              return (
                <div key={event.year} className="relative flex items-center justify-between w-full group">
                  
                  {/* Left Content */}
                  <div className={`w-5/12 ${isEven ? 'text-right pr-8' : 'invisible'}`}>
                    <h3 className="text-3xl font-serif text-[#D4AF37] mb-1">{event.year}</h3>
                    <h4 className="text-lg font-bold text-[#3B291A] uppercase tracking-wider mb-2">{event.title}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed max-w-sm ml-auto">
                      {event.description}
                    </p>
                  </div>

                  {/* Center Dot */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center justify-center w-6 h-6 rounded-full bg-white border-4 border-[#D4AF37] z-10 group-hover:scale-125 transition-transform"></div>

                  {/* Right Content */}
                  <div className={`w-5/12 ${!isEven ? 'text-left pl-8' : 'invisible'}`}>
                    <h3 className="text-3xl font-serif text-[#D4AF37] mb-1">{event.year}</h3>
                    <h4 className="text-lg font-bold text-[#3B291A] uppercase tracking-wider mb-2">{event.title}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed max-w-sm">
                      {event.description}
                    </p>
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JourneyTimeline;
